import WithLink from "features/common/components/WithLink";
import PrimaryButtonAquamarine from "./PrimaryButtonAquamarine";

export default WithLink(PrimaryButtonAquamarine);
